module.exports = __webpack_public_path__ + "ay.no1.88d3a367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ay.no1.jpg
// module id = 0/jl
// module chunks = 0